import Epg from './Epg';

export interface IEvent {
  data?: any;
  name: string;
}

export type EventCallback = (event: IEvent) => void;

export interface IPlayer {
  on: (eventName: string, cb: EventCallback) => void;
  off: (eventName: string, cb: EventCallback) => void;
  emit: (eventName: string, data?: any) => void;
  get: (propertyName: string) => any;
  set: (propertyName: string, data: any) => void;
  registerProperty: (
    propertyName: string,
    defaultValue: any,
    resetable?: boolean,
  ) => void;
  reset: () => void;
}

export interface ICategory {
  id: number;
  external_id: number;
  title: string;
}

export enum ChannelType {
  REGULAR_CHANNEL = 'regularChannel',
  DVR_CHANNEL = 'dvrChannel',
  VOD_CHANNEL = 'vodChannel',
}

export enum ProgramState {
  PAST,
  CURRENT,
  FUTURE,
}

const constsPrefix = 'epg:';
export const Consts = {
  PROPERTY_CURRENT_CHANNEL: `${constsPrefix}currentChannel`,
  PROPERTY_CURRENT_PROGRAM: `${constsPrefix}currentProgram`,
  PROPERTY_CURRENT_PROGRAM_TIME: `${constsPrefix}currentProgramTime`,
  PROPERTY_CURRENT_TIMESTAMP: `${constsPrefix}currentTimestamp`,
  PROPERTY_TIME_OFFSET: `${constsPrefix}timeOffset`,
  PROPERTY_ALL_CHANNELS_URL: `${constsPrefix}allChannelsUrl`,
  PROPERTY_SHOW_ALL_CHANNELS_BUTTON: `${constsPrefix}showAllChannelsButton`,
  PROPERTY_PLAYING_PROGRAM: 'interactiveChannel:currentPlayingProgram',
  PROPERTY_INIT_OPTIONS: `${constsPrefix}initOptions`,
  PROPERTY_GET_CHANNEL_BY_ID: `${constsPrefix}getChannelById`,
  EVENT_TIME_UPDATE: `${constsPrefix}private:timeUpdate`,
  EVENT_CURRENT_PROGRAM_CHANGED: `${constsPrefix}currentProgramChanged`,
  EVENT_NEED_TO_LOAD_UPDATED_PROGRAM_LIST: `${constsPrefix}private:needToLoadUpdatedProgramList`,
  EVENT_NEED_TO_LOAD_EXTENDED_PROGRAM_LIST: `${constsPrefix}needToLoadExtendedProgramList`,
  EVENT_ACTIVE_PROGRAM_CHANGED: `${constsPrefix}activeProgramChanged`,
  EVENT_CURRENT_PROGRAM_LIST_UPDATED: `${constsPrefix}currentProgramListUpdated`,
  EVENT_CHANNELS_READY: `${constsPrefix}channelsReady`,
  EVENT_PROGRAMS_READY: `${constsPrefix}programsReady`,
  EVENT_CHANNEL_SWITCH: `${constsPrefix}channelSwitch`,
  EVENT_PLAYER_FAVORITE_BUTTON_CLICK: 'player:favoriteButtonClick',
  EVENT_FAVORITE_TOGGLED: `${constsPrefix}favoriteToggled`,
  EVENT_LOAD_PROGRAMS_FOR_CHANNEL: `${constsPrefix}loadProgramsForChannel`,
  EVENT_SUBSCRIPTION_INFO_LOADED: `${constsPrefix}subscriptionInfoLoaded`,
  EVENT_PROGRAM_VIRTUAL_STREAM_UPDATED: `${constsPrefix}programVirtualStreamUpdated`,
  EVENT_INIT: `${constsPrefix}init`,
  EVENT_INITED: `${constsPrefix}inited`,
  EVENT_GENRE_EXPANDED_MAP: `${constsPrefix}genresExpandedState`,
  EVENT_GENRE_EXPANDED: `${constsPrefix}genre:expandChange`,
};

export default Epg;
